// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes showPanel {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.snapshots {
  flex-direction: row;
  flex: 1;
  margin-bottom: 0;
  display: flex;
  position: relative;
  overflow: hidden;
}

.snapshots .showcontent {
  opacity: 1;
  transform: translateX(0);
}

.snapshots .hidecontent > * {
  display: none;
}

.snapshots .showpanel {
  animation: 1s showPanel;
}

.snapshots .Select-control {
  border: 1px solid #ccc;
  border-radius: 0;
}

.snapshots .filter-table td {
  padding-bottom: 10px;
}

.snapshots .filter-table tr:last-of-type td {
  padding-bottom: 0;
}

.snapshots .nav-tabs-custom {
  margin-bottom: 0;
}

.snapshots .nav-tabs-custom > .tab-content {
  padding: 15px;
}

.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) {
  padding-left: var(--base-sizes-3);
  padding-right: var(--base-sizes-3);
  flex-wrap: wrap;
  display: flex;
  background: none !important;
}

.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) * {
  cursor: pointer;
}

.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {
  border-left: 1px solid #ddd !important;
  border-right: 1px solid #ddd !important;
}

.snapshots .nav-tabs-custom > .nav-tabs > li:last-of-type {
  margin-right: 0;
}

.snapshots .snapshots-infobox {
  width: 100%;
}

.snapshots .snapshots-infobox__cell {
  padding-left: 15px;
  padding-right: 15px;
}

.snapshots .snapshots-infobox__th {
  border-bottom: 1px solid #fff;
}

.snapshot-full-width {
  flex-direction: column;
  flex: 1;
  display: flex;
}

.snapshots-leftwrapper {
  z-index: 1;
  min-width: 350px;
  box-shadow: none;
  background: #eeeced;
  flex-direction: column;
  flex: 0;
  display: flex;
  overflow-y: auto;
}

@media (width >= 768px) {
  .snapshots-leftwrapper {
    min-width: 350px;
  }
}

.snapshots-leftwrapper__top {
  height: 3px;
  line-height: 3px;
}

.snapshots-leftwrapper__bottom {
  height: 15px;
  line-height: 15px;
}

.snapshots-upload-hidden {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: -5000px;
}

.snapshots-menu__start {
  padding-top: 12px;
  padding-bottom: 12px;
}

.snapshots-menu__item {
  border-right: 2px solid #d6d4d5;
  position: relative;
}

.snapshots-menu__item--active {
  background: #fff;
  border-right-color: #fff;
}

.snapshots-menu__item--active:before {
  content: " ";
  border-top: 2px solid #d6d4d5;
  padding: 0;
  line-height: 1px;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: -2px;
}

.snapshots-menu__item--active:after {
  content: " ";
  border-bottom: 2px solid #d6d4d5;
  padding: 0;
  line-height: 1px;
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: -2px;
}

.snapshots-right-wrapper {
  opacity: 0;
  background: #fff;
  flex-direction: column;
  flex: 1;
  padding: 0;
  transition: all 1s;
  display: flex;
  transform: translateX(-100%);
}

@media (width >= 768px) {
  .snapshots-right-wrapper {
    width: 100%;
  }
}

.snapshots-name__wrapper {
  cursor: text;
  word-break: break-word;
  background: #fff;
  align-self: flex-start;
  width: 100%;
  margin-bottom: 5px;
  padding-top: 2.5px;
  padding-bottom: 2.5px;
}

.snapshots-name__wrapper:hover {
  background: #f4f4f4;
}

.snapshots-name__wrapper--edit {
  padding: 0;
}

.snapshots-name__wrapper--edit:hover {
  background: #fff;
}

.snapshots-name__input--error, .snapshots-name__input--error:focus {
  border-color: var(--danger);
}

.snapshots-name__error {
  color: var(--danger);
}

.snapshots-content__info {
  flex-direction: column;
  flex-shrink: 0;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  overflow-y: auto;
}

.snapshots-settings {
  z-index: 2;
  background: #fff;
  inset: 0;
}

.snapshots-settings__play {
  cursor: pointer;
  width: 30px;
  height: 30px;
  transition: all .5s;
  display: inline-block;
}

.snapshots-settings__play .triangle {
  stroke: #000;
  transform-origin: center;
  transition: all .1s ease-in-out .3s;
  transform: scale(1);
}

.snapshots-settings__play .circle {
  stroke: #000;
  stroke-dasharray: 650;
  stroke-dashoffset: 650px;
  opacity: .3;
  transition: all .5s ease-in-out;
}

.snapshots-settings__play:hover .triangle {
  opacity: 1;
  stroke: #000;
  transform-origin: center;
  transition: all .1s ease-in-out;
  transform: scale(.8);
}

.snapshots-settings__play:hover .circle {
  stroke-dashoffset: 0;
  opacity: 1;
}

.snapshots-settings__close .outer {
  cursor: pointer;
  width: 46px;
  height: 42px;
  margin-top: 0;
  position: relative;
}

.snapshots-settings__close .inner {
  width: inherit;
  text-align: center;
}

.snapshots-settings__close label {
  text-transform: uppercase;
  color: #333;
  opacity: 0;
  cursor: pointer;
  font-size: .8em;
  font-weight: normal;
  line-height: 42px;
  transition: all .3s ease-in;
}

.snapshots-settings__close .inner:before, .snapshots-settings__close .inner:after {
  content: "";
  height: 1px;
  width: inherit;
  background: #333;
  transition: all .3s ease-in;
  position: absolute;
  left: 0;
}

.snapshots-settings__close .inner:before {
  width: 70%;
  top: 49%;
  left: 12%;
  transform: rotate(45deg);
}

.snapshots-settings__close .inner:after {
  width: 70%;
  bottom: 50%;
  left: 12%;
  transform: rotate(-45deg);
}

.snapshots-settings__close .outer:hover label {
  opacity: 1;
}

.snapshots-settings__close .outer:hover .inner:before, .snapshots-settings__close .outer:hover .inner:after {
  width: 100%;
  left: 0;
  transform: rotate(0);
}

.snapshots-settings__close .outer:hover .inner:before {
  top: 7px;
}

.snapshots-settings__close .outer:hover .inner:after {
  bottom: 7px;
}

.snapshots-settings .nav > li > a {
  padding-top: 12px;
  padding-bottom: 11px;
}

.snapshots .snapshots-settings.overflow-y-auto {
  scrollbar-gutter: stable;
}

.snapshots-content__tabs {
  flex-direction: column;
  flex: 1;
  display: flex;
}

.snapshots-content__tabs-empty-space {
  width: 10px;
  height: 10px;
}

.snapshots-content__tabs-content-wrapper {
  min-height: 200px;
}

.snapshots-content__tabs-box-body {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.snapshots-content__sites-detail {
  max-height: 122px;
  overflow-y: auto;
}

.snapshots-infobox__number {
  font-size: 15px;
  font-weight: bold;
  display: block;
}

.snapshots-infobox__center--big {
  padding-top: 15px;
  font-size: 24px;
}

.snapshots-infobox__queue {
  padding-top: 10px;
}

.snapshots-content-name__heading {
  margin: 0;
  line-height: 28px;
}

.snapshots-content-name__edit-icon {
  margin-top: 7px;
  margin-left: 15px;
  display: inline-block;
}

.snapshots-content-note__wrapper {
  cursor: text;
  background: #fff;
  flex-direction: row;
  padding: 5px 5px 5px 0;
  display: flex;
}

.snapshots-content-note__wrapper:hover {
  background: #f4f4f4;
}

.snapshots-content-note__wrapper--edit:hover {
  background: #fff;
}

.snapshots-content-note__row:after {
  content: "​";
}

.snapshots-content-note__edit-icon {
  margin-top: 2px;
  margin-left: 15px;
  display: inline-block;
}

.snapshots-content__text {
  flex: 1;
}

.snapshots-content__text:after {
  content: "​";
}

.snapshots-content__text--empty:after {
  content: "";
}

.snapshots-content__detail-cell {
  margin-bottom: 5px;
  margin-right: 50px;
}

.snapshots-content__detail-cell:after {
  content: "​";
}

.snapshots-content__labels-wrapper {
  float: left;
  min-width: 70px;
  margin-right: 5px;
}

.snapshots-loading-snapshot {
  background-color: var(--backgroundAqua);
  color: #fff;
}

.snapshots-buttons__more-options {
  position: absolute;
  top: 2rem;
  right: 0;
}

.snapshots-add-device__toggle-label {
  vertical-align: middle;
  margin: 0 10px 6px 5px;
  display: inline-block;
}

.snapshots-buttons__button-icon {
  position: absolute;
  bottom: 0;
  left: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/SnapshotManagement/styles/SnapshotManagement.css","webpack://./services/frontend/app/pages/SnapshotManagement/styles/SnapshotManagement.css"],"names":[],"mappings":"AADA;ECEE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd","sourcesContent":["@keyframes showPanel {\n  from {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.snapshots {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  margin-bottom: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.snapshots .showcontent {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n.snapshots .hidecontent > * {\n      display: none;\n    }\n\n.snapshots .showpanel {\n    animation: showPanel 1s;\n  }\n\n.snapshots .Select-control {\n    border-radius: 0;\n    border: 1px solid #ccc;\n  }\n\n.snapshots .filter-table td {\n    padding-bottom: 10px;\n  }\n\n.snapshots .filter-table tr:last-of-type td {\n    padding-bottom: 0;\n  }\n\n.snapshots .nav-tabs-custom {\n    margin-bottom: 0;\n  }\n\n.snapshots .nav-tabs-custom > .tab-content {\n    padding: 15px;\n  }\n\n.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) {\n    background: none !important;\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: var(--base-sizes-3);\n    padding-right: var(--base-sizes-3);\n  }\n\n.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) * {\n  cursor: pointer;\n}\n\n.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n    border-right: 1px solid #ddd !important;\n    border-left: 1px solid #ddd !important;\n  }\n\n.snapshots .nav-tabs-custom > .nav-tabs > li:last-of-type {\n    margin-right: 0;\n  }\n\n.snapshots .snapshots-infobox {\n    width: 100%;\n  }\n\n.snapshots .snapshots-infobox__cell {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n\n.snapshots .snapshots-infobox__th {\n      border-bottom: 1px solid #fff;\n    }\n\n.snapshot-full-width {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n}\n\n.snapshots-leftwrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 0%;\n  min-width: 350px;\n  z-index: 1;\n  overflow-y: auto;\n  background: #eeeced;\n  box-shadow: none;\n}\n\n@media (min-width: 768px) {\n\n.snapshots-leftwrapper {\n    min-width: 350px\n}\n  }\n\n.snapshots-leftwrapper__top {\n  height: 3px;\n  line-height: 3px;\n}\n\n.snapshots-leftwrapper__bottom {\n  height: 15px;\n  line-height: 15px;\n}\n\n.snapshots-upload-hidden {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: -5000px;\n}\n\n.snapshots-menu__start {\n  padding-bottom: 12px;\n  padding-top: 12px;\n}\n\n.snapshots-menu__item {\n  border-right: 2px solid #d6d4d5;\n  position: relative;\n}\n\n.snapshots-menu__item--active {\n    background: #fff;\n    border-right-color: #fff;\n  }\n\n.snapshots-menu__item--active:before {\n      content: '\\a0';\n      display: block;\n      padding: 0;\n      line-height: 1px;\n      border-top: 2px solid #d6d4d5;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: -2px;\n    }\n\n.snapshots-menu__item--active:after {\n      content: '\\a0';\n      display: block;\n      padding: 0;\n      line-height: 1px;\n      border-bottom: 2px solid #d6d4d5;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: -2px;\n    }\n\n.snapshots-right-wrapper {\n  background: #fff;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  opacity: 0;\n  transition: all 1s ease;\n  transform: translateX(-100%);\n}\n\n@media (min-width: 768px) {\n\n.snapshots-right-wrapper {\n    width: 100%\n}\n  }\n\n.snapshots-name__wrapper {\n  margin-bottom: 5px;\n  padding-top: 2.5px;\n  padding-bottom: 2.5px;\n  align-self: flex-start;\n  width: 100%;\n  background: #fff;\n  cursor: text;\n  word-break: break-word;\n}\n\n.snapshots-name__wrapper:hover {\n    background: #f4f4f4;\n  }\n\n.snapshots-name__wrapper--edit {\n    padding: 0;\n  }\n\n.snapshots-name__wrapper--edit:hover {\n      background: #fff;\n    }\n\n.snapshots-name__input--error,\n  .snapshots-name__input--error:focus {\n    border-color: var(--danger);\n  }\n\n.snapshots-name__error {\n  color: var(--danger);\n}\n\n.snapshots-content__info {\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.snapshots-settings {\n  background: rgb(255, 255, 255);\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 2;\n}\n\n.snapshots-settings__play {\n    display: inline-block;\n    transition: all 0.5s ease;\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n  }\n\n.snapshots-settings__play .triangle {\n      transition: all 0.1s ease-in-out 0.3s;\n      stroke: #000;\n      transform: scale(1, 1);\n      transform-origin: center;\n    }\n\n.snapshots-settings__play .circle {\n      stroke: #000;\n      stroke-dasharray: 650;\n      stroke-dashoffset: 650;\n      transition: all 0.5s ease-in-out;\n      opacity: 0.3;\n    }\n\n.snapshots-settings__play:hover .triangle {\n        opacity: 1;\n        stroke: #000;\n        transform-origin: center;\n        transform: scale(0.8, 0.8);\n        transition: all 0.1s ease-in-out;\n      }\n\n.snapshots-settings__play:hover .circle {\n        stroke-dashoffset: 0;\n        opacity: 1;\n      }\n\n.snapshots-settings__close .outer {\n      position: relative;\n      width: 46px;\n      height: 42px;\n      margin-top: 0;\n      cursor: pointer;\n    }\n\n.snapshots-settings__close .inner {\n      width: inherit;\n      text-align: center;\n    }\n\n.snapshots-settings__close label {\n      font-weight: normal;\n      font-size: 0.8em;\n      line-height: 42px;\n      text-transform: uppercase;\n      color: #333;\n      transition: all 0.3s ease-in;\n      opacity: 0;\n      cursor: pointer;\n    }\n\n.snapshots-settings__close .inner:before,\n    .snapshots-settings__close .inner:after {\n      position: absolute;\n      content: '';\n      height: 1px;\n      width: inherit;\n      background: #333;\n      left: 0;\n      transition: all 0.3s ease-in;\n    }\n\n.snapshots-settings__close .inner:before {\n      width: 70%;\n      top: 49%;\n      left: 12%;\n      transform: rotate(45deg);\n    }\n\n.snapshots-settings__close .inner:after {\n      width: 70%;\n      bottom: 50%;\n      left: 12%;\n      transform: rotate(-45deg);\n    }\n\n.snapshots-settings__close .outer:hover label {\n      opacity: 1;\n    }\n\n.snapshots-settings__close .outer:hover .inner:before,\n    .snapshots-settings__close .outer:hover .inner:after {\n      transform: rotate(0);\n      width: 100%;\n      left: 0;\n    }\n\n.snapshots-settings__close .outer:hover .inner:before {\n      top: 7px;\n    }\n\n.snapshots-settings__close .outer:hover .inner:after {\n      bottom: 7px;\n    }\n\n.snapshots-settings .nav > li > a {\n    padding-top: 12px;\n    padding-bottom: 11px;\n  }\n\n.snapshots .snapshots-settings.overflow-y-auto {\n  scrollbar-gutter: stable;\n}\n\n.snapshots-content__tabs {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n}\n\n.snapshots-content__tabs-empty-space {\n  width: 10px;\n  height: 10px;\n}\n\n.snapshots-content__tabs-content-wrapper {\n  min-height: 200px;\n}\n\n.snapshots-content__tabs-box-body {\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  left: 50%;\n}\n\n.snapshots-content__sites-detail {\n  max-height: 122px;\n  overflow-y: auto;\n}\n\n.snapshots-infobox__number {\n  display: block;\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.snapshots-infobox__center--big {\n  font-size: 24px;\n  padding-top: 15px;\n}\n\n.snapshots-infobox__queue {\n  padding-top: 10px;\n}\n\n.snapshots-content-name__heading {\n  line-height: 28px;\n  margin: 0;\n}\n\n.snapshots-content-name__edit-icon {\n  display: inline-block;\n  margin-left: 15px;\n  margin-top: 7px;\n}\n\n.snapshots-content-note__wrapper {\n  background: #fff;\n  cursor: text;\n  display: flex;\n  flex-direction: row;\n  padding: 5px 5px 5px 0;\n}\n\n.snapshots-content-note__wrapper:hover {\n    background: #f4f4f4;\n  }\n\n.snapshots-content-note__wrapper--edit:hover {\n    background: #fff;\n  }\n\n.snapshots-content-note__row:after {\n    content: '\\200b';\n  }\n\n.snapshots-content-note__edit-icon {\n  display: inline-block;\n  margin-top: 2px;\n  margin-left: 15px;\n}\n\n.snapshots-content__text {\n  flex: 1;\n}\n\n.snapshots-content__text:after {\n    content: '\\200b';\n  }\n\n.snapshots-content__text--empty:after {\n    content: '';\n  }\n\n.snapshots-content__detail-cell {\n  margin-bottom: 5px;\n  margin-right: 50px;\n}\n\n.snapshots-content__detail-cell:after {\n    content: '\\200b';\n  }\n\n.snapshots-content__labels-wrapper {\n  float: left;\n  margin-right: 5px;\n  min-width: 70px;\n}\n\n.snapshots-loading-snapshot {\n  background-color: var(--backgroundAqua);\n  color: #fff;\n}\n\n.snapshots-buttons__more-options {\n  position: absolute;\n  right: 0;\n  top: 2rem;\n}\n\n.snapshots-add-device__toggle-label {\n  vertical-align: middle;\n  display: inline-block;\n  margin: 0 10px 6px 5px;\n}\n\n.snapshots-buttons__button-icon {\n  position: absolute;\n  left: 1.5rem;\n  bottom: 0;\n}\n","@keyframes showPanel {\n  from {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.snapshots {\n  flex-direction: row;\n  flex: 1;\n  margin-bottom: 0;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\n\n.snapshots .showcontent {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.snapshots .hidecontent > * {\n  display: none;\n}\n\n.snapshots .showpanel {\n  animation: 1s showPanel;\n}\n\n.snapshots .Select-control {\n  border: 1px solid #ccc;\n  border-radius: 0;\n}\n\n.snapshots .filter-table td {\n  padding-bottom: 10px;\n}\n\n.snapshots .filter-table tr:last-of-type td {\n  padding-bottom: 0;\n}\n\n.snapshots .nav-tabs-custom {\n  margin-bottom: 0;\n}\n\n.snapshots .nav-tabs-custom > .tab-content {\n  padding: 15px;\n}\n\n.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) {\n  padding-left: var(--base-sizes-3);\n  padding-right: var(--base-sizes-3);\n  flex-wrap: wrap;\n  display: flex;\n  background: none !important;\n}\n\n.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) * {\n  cursor: pointer;\n}\n\n.snapshots .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n  border-left: 1px solid #ddd !important;\n  border-right: 1px solid #ddd !important;\n}\n\n.snapshots .nav-tabs-custom > .nav-tabs > li:last-of-type {\n  margin-right: 0;\n}\n\n.snapshots .snapshots-infobox {\n  width: 100%;\n}\n\n.snapshots .snapshots-infobox__cell {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.snapshots .snapshots-infobox__th {\n  border-bottom: 1px solid #fff;\n}\n\n.snapshot-full-width {\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n}\n\n.snapshots-leftwrapper {\n  z-index: 1;\n  min-width: 350px;\n  box-shadow: none;\n  background: #eeeced;\n  flex-direction: column;\n  flex: 0;\n  display: flex;\n  overflow-y: auto;\n}\n\n@media (width >= 768px) {\n  .snapshots-leftwrapper {\n    min-width: 350px;\n  }\n}\n\n.snapshots-leftwrapper__top {\n  height: 3px;\n  line-height: 3px;\n}\n\n.snapshots-leftwrapper__bottom {\n  height: 15px;\n  line-height: 15px;\n}\n\n.snapshots-upload-hidden {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: -5000px;\n}\n\n.snapshots-menu__start {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.snapshots-menu__item {\n  border-right: 2px solid #d6d4d5;\n  position: relative;\n}\n\n.snapshots-menu__item--active {\n  background: #fff;\n  border-right-color: #fff;\n}\n\n.snapshots-menu__item--active:before {\n  content: \" \";\n  border-top: 2px solid #d6d4d5;\n  padding: 0;\n  line-height: 1px;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: -2px;\n}\n\n.snapshots-menu__item--active:after {\n  content: \" \";\n  border-bottom: 2px solid #d6d4d5;\n  padding: 0;\n  line-height: 1px;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: -2px;\n}\n\n.snapshots-right-wrapper {\n  opacity: 0;\n  background: #fff;\n  flex-direction: column;\n  flex: 1;\n  padding: 0;\n  transition: all 1s;\n  display: flex;\n  transform: translateX(-100%);\n}\n\n@media (width >= 768px) {\n  .snapshots-right-wrapper {\n    width: 100%;\n  }\n}\n\n.snapshots-name__wrapper {\n  cursor: text;\n  word-break: break-word;\n  background: #fff;\n  align-self: flex-start;\n  width: 100%;\n  margin-bottom: 5px;\n  padding-top: 2.5px;\n  padding-bottom: 2.5px;\n}\n\n.snapshots-name__wrapper:hover {\n  background: #f4f4f4;\n}\n\n.snapshots-name__wrapper--edit {\n  padding: 0;\n}\n\n.snapshots-name__wrapper--edit:hover {\n  background: #fff;\n}\n\n.snapshots-name__input--error, .snapshots-name__input--error:focus {\n  border-color: var(--danger);\n}\n\n.snapshots-name__error {\n  color: var(--danger);\n}\n\n.snapshots-content__info {\n  flex-direction: column;\n  flex-shrink: 0;\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  display: flex;\n  overflow-y: auto;\n}\n\n.snapshots-settings {\n  z-index: 2;\n  background: #fff;\n  inset: 0;\n}\n\n.snapshots-settings__play {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  transition: all .5s;\n  display: inline-block;\n}\n\n.snapshots-settings__play .triangle {\n  stroke: #000;\n  transform-origin: center;\n  transition: all .1s ease-in-out .3s;\n  transform: scale(1);\n}\n\n.snapshots-settings__play .circle {\n  stroke: #000;\n  stroke-dasharray: 650;\n  stroke-dashoffset: 650px;\n  opacity: .3;\n  transition: all .5s ease-in-out;\n}\n\n.snapshots-settings__play:hover .triangle {\n  opacity: 1;\n  stroke: #000;\n  transform-origin: center;\n  transition: all .1s ease-in-out;\n  transform: scale(.8);\n}\n\n.snapshots-settings__play:hover .circle {\n  stroke-dashoffset: 0;\n  opacity: 1;\n}\n\n.snapshots-settings__close .outer {\n  cursor: pointer;\n  width: 46px;\n  height: 42px;\n  margin-top: 0;\n  position: relative;\n}\n\n.snapshots-settings__close .inner {\n  width: inherit;\n  text-align: center;\n}\n\n.snapshots-settings__close label {\n  text-transform: uppercase;\n  color: #333;\n  opacity: 0;\n  cursor: pointer;\n  font-size: .8em;\n  font-weight: normal;\n  line-height: 42px;\n  transition: all .3s ease-in;\n}\n\n.snapshots-settings__close .inner:before, .snapshots-settings__close .inner:after {\n  content: \"\";\n  height: 1px;\n  width: inherit;\n  background: #333;\n  transition: all .3s ease-in;\n  position: absolute;\n  left: 0;\n}\n\n.snapshots-settings__close .inner:before {\n  width: 70%;\n  top: 49%;\n  left: 12%;\n  transform: rotate(45deg);\n}\n\n.snapshots-settings__close .inner:after {\n  width: 70%;\n  bottom: 50%;\n  left: 12%;\n  transform: rotate(-45deg);\n}\n\n.snapshots-settings__close .outer:hover label {\n  opacity: 1;\n}\n\n.snapshots-settings__close .outer:hover .inner:before, .snapshots-settings__close .outer:hover .inner:after {\n  width: 100%;\n  left: 0;\n  transform: rotate(0);\n}\n\n.snapshots-settings__close .outer:hover .inner:before {\n  top: 7px;\n}\n\n.snapshots-settings__close .outer:hover .inner:after {\n  bottom: 7px;\n}\n\n.snapshots-settings .nav > li > a {\n  padding-top: 12px;\n  padding-bottom: 11px;\n}\n\n.snapshots .snapshots-settings.overflow-y-auto {\n  scrollbar-gutter: stable;\n}\n\n.snapshots-content__tabs {\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n}\n\n.snapshots-content__tabs-empty-space {\n  width: 10px;\n  height: 10px;\n}\n\n.snapshots-content__tabs-content-wrapper {\n  min-height: 200px;\n}\n\n.snapshots-content__tabs-box-body {\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.snapshots-content__sites-detail {\n  max-height: 122px;\n  overflow-y: auto;\n}\n\n.snapshots-infobox__number {\n  font-size: 15px;\n  font-weight: bold;\n  display: block;\n}\n\n.snapshots-infobox__center--big {\n  padding-top: 15px;\n  font-size: 24px;\n}\n\n.snapshots-infobox__queue {\n  padding-top: 10px;\n}\n\n.snapshots-content-name__heading {\n  margin: 0;\n  line-height: 28px;\n}\n\n.snapshots-content-name__edit-icon {\n  margin-top: 7px;\n  margin-left: 15px;\n  display: inline-block;\n}\n\n.snapshots-content-note__wrapper {\n  cursor: text;\n  background: #fff;\n  flex-direction: row;\n  padding: 5px 5px 5px 0;\n  display: flex;\n}\n\n.snapshots-content-note__wrapper:hover {\n  background: #f4f4f4;\n}\n\n.snapshots-content-note__wrapper--edit:hover {\n  background: #fff;\n}\n\n.snapshots-content-note__row:after {\n  content: \"​\";\n}\n\n.snapshots-content-note__edit-icon {\n  margin-top: 2px;\n  margin-left: 15px;\n  display: inline-block;\n}\n\n.snapshots-content__text {\n  flex: 1;\n}\n\n.snapshots-content__text:after {\n  content: \"​\";\n}\n\n.snapshots-content__text--empty:after {\n  content: \"\";\n}\n\n.snapshots-content__detail-cell {\n  margin-bottom: 5px;\n  margin-right: 50px;\n}\n\n.snapshots-content__detail-cell:after {\n  content: \"​\";\n}\n\n.snapshots-content__labels-wrapper {\n  float: left;\n  min-width: 70px;\n  margin-right: 5px;\n}\n\n.snapshots-loading-snapshot {\n  background-color: var(--backgroundAqua);\n  color: #fff;\n}\n\n.snapshots-buttons__more-options {\n  position: absolute;\n  top: 2rem;\n  right: 0;\n}\n\n.snapshots-add-device__toggle-label {\n  vertical-align: middle;\n  margin: 0 10px 6px 5px;\n  display: inline-block;\n}\n\n.snapshots-buttons__button-icon {\n  position: absolute;\n  bottom: 0;\n  left: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
